import Vue from "vue";
import api from "@/api";
import http from "@/api/http";
import i18n from '@/i18n'
import _ from "lodash";
import { isEmpty } from "lodash";
export default {
  namespaced: true,
  state: {
    config: {
      api_key: localStorage.getItem("api-key") || null,
    },
    theme: {},
    locations: [],
    business: {},
    categories: [],
    postBody: {},
    selectedLocation: {},
    availableLocations: [],
    favorites: [],
    locationReviews: [],
    isLoadingCategories: false,
    trackingStatus: null,
    currentLanguage: null,
    isUKApp: true,
    currentCurrency: '£',
    nativeApplePayStatus: null,
    nativeGooglePayStatus: null,
    channel: 4, // default value for the web browsers
    trackedOrders: [],
    storeLinks: null,
    providerName: null,
    webAppVersion: null
  },

  mutations: {
    setApiKey: (state, apiKey) => {
      state.config.api_key = apiKey;
      /* Add Api Key Header to http */
      http.defaults.headers.common["ApiKey"] = apiKey;
      localStorage.setItem("api-key", apiKey);
    },
    setTheme: (state, theme) =>
      Vue.set(state, "theme", Object.assign({}, theme)),
    setLocations: (state, locations) => Vue.set(state, "locations", locations),
    setSearchedLocations: (state, availableLocations) =>
      Vue.set(state, "availableLocations", availableLocations),
    setBusiness: (state, business) =>
      Vue.set(state, "business", Object.assign({}, business)),
    setCategories: (state, payload) => {
      if (!state.categories || _.isObject(state.categories) || (state.categories.length && !state.categories[0].new_format)) {
        Vue.set(state, "categories", [])
      }
      const existsAtIndex = state.categories.findIndex(o => o.location_id === payload.location_id)
      if (existsAtIndex != -1) {
        state.categories[existsAtIndex] = payload
      } else {
        state.categories.unshift(payload) // insert the element to the begining of the array
      }
    },
    setDocs: (state, docs) => {
      state.docs = docs;
    },
    setSelectedLocation: (state, _selectedLocation) => {
      state.selectedLocation = _selectedLocation;
      state.currentCurrency = _selectedLocation && _selectedLocation.currency ? _selectedLocation.currency.raw_symbol : "£";
    },
    setLocationReviews: (state, reviews) => {
      state.locationReviews = reviews;
    },
    setIsLoadingCategories: (state, isLoading) => {
      state.isLoadingCategories = isLoading
    },
    setTrackingStatus: (state, statusValue) => {
      state.trackingStatus = statusValue
    },
    setCurrentLangauge: (state, code) => {
      i18n.locale = code;
      state.currentLanguage = code
    },
    setIsUKApp: (state, isUK) => {
      state.isUKApp = isUK
    },
    setNativeApplePayStatus: (state, value) => {
      state.nativeApplePayStatus = value
    },
    setNativeGooglePaystatus: (state, value) => {
      state.nativeGooglePayStatus = value
    },
    setChannel: (state, _channel) => {
      state.channel = _channel
    },
    setTreckedOrder: (state, payload) => {
      const existsAtIndex = state.trackedOrders.findIndex(o => o.id === payload.id)

      if (existsAtIndex != -1) {
        state.trackedOrders[existsAtIndex] = payload
      } else {
        state.trackedOrders.unshift(payload) // insert the element to the begining of the array
      }
    },

    setStoreLinks: (state, payload) => {
      state.storeLinks = payload
    },
    setProviderName: (state, provider) => {
      state.providerName = provider;
    },
    INIT_DATA: (state) => {
      state.locationReviews = null;
      state.trackedOrders = []
      state.providerName = null;
    },
    setWebAppVersion: (state, version) => {
      state.webAppVersion = version;
    },
  },

  getters: {
    getLocationBySlug: (state) => (location) => {
      return state.locations.find((loc) => loc.slug === location);
    },
    getCategoryById: (state) => (categoryId) => {
      if (categoryId > 0)
        return state.categories.find((cat) => cat.id === categoryId);
      else return state.categories[0];
    },
    isLoadingCategories: (state) => { return state.isLoadingCategories },
    getTrackingStatus: (state) => { return state.trackingStatus },
    getCurrentLanguage: (state) => { return state.currentLanguage },
    getIsUKApp: (state) => { return state.isUKApp },
    getNativeApplePayStatus: (state) => { return state.nativeApplePayStatus },
    getNativeGooglePayStatus: (state) => { return state.nativeGooglePayStatus },
    getChannel: (state) => { return state.channel },
    getTrackedOrder: (state) => { return state.trackedOrders },
    getStoreLinks: (state) => { return state.storeLinks },
    getProviderName: (state) => { return state.providerName },
    getBusiness: (state) => { return state.business },
    getCategories: (state) => { return state.categories },
    myTheme: (state) => { return state.theme },
  },

  actions: {
    fetchTheme: ({ commit, state }, id) => {
      return new Promise((resolve, reject) => {
        api.init
          .website()
          .then((response) => {
            /* set the ApiKey in store */
            commit("setApiKey", response.data.api_key);
            commit("setTheme", response.data.theme);
            commit("setLocations", response.data.locations);
            commit("setSearchedLocations", response.data.locations);
            commit("setBusiness", response.data.business);
            commit("setStoreLinks", {
              appStore: response.data.app_store_link,
              playStore: response.data.google_play_link
            })

            if (response.data.locations.length == 1 || isEmpty(state.selectedLocation)) {
              commit("setSelectedLocation", response.data.locations[0]);
            }
            else if (state.selectedLocation) {
              commit(
                "setSelectedLocation",
                response.data.locations.find(
                  (l) => l.id == state.selectedLocation.id
                )
              );
            }

            if (!state.currentLanguage) {
              if (response.data.business) {
                commit("setCurrentLangauge", response.data.business.territory.toLowerCase())
              } else {
                commit("setCurrentLangauge", "en")
              }
            }

            commit("setIsUKApp", response.data.business.territory.toLowerCase() == "en");
            
            if(id){
              resolve(response.data.locations.find(
                (l) => l.id == id
              ));
            }
            resolve();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    fetchCategories: ({ commit }, idLocation) => {
      return new Promise((resolve, reject) => {
        commit("setIsLoadingCategories", true)
        api.locations
          .categories(idLocation)
          .then((response) => {
            commit("setCategories", { location_id: idLocation, categories: response.data, new_format: true });
            resolve(response.data);
          })
          .catch((e) => {
            /* TODO: handle error */
            commit("setCategories", { location_id: idLocation, categories: [], new_format: true });
            reject(e.response);
          }).finally(() => {
            commit("setIsLoadingCategories", false)
          })
      });
    },
    fetchLocation: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.locations
          .location(data.id, data)
          .then((response) => {
            commit("setSelectedLocation", response.data);
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    getPublicDocsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.publicdocs
          .getPublicDocuments()
          .then((response) => {
            commit("setDocs", response.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    fetchLocationsByPostCode: ({ commit }, postcode) => {
      return new Promise((resolve, reject) => {
        api.locations
          .search(postcode)
          .then((result) => {
            commit("setSearchedLocations", result.data.data);
            resolve(result);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    storeSelectedLocation: ({ commit }, _location) => {
      commit("setSelectedLocation", _location);
    },
    /*****************************Reviews*****************************/
    fetchLocationReviews: ({ commit }, id) => {
      return new Promise((resolve, reject) => {
        api.reviews
          .getLocationReviews(id)
          .then((result) => {
            commit("setLocationReviews", result.data);
            resolve(result);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    saveTrackingStatus: ({ commit }, status) => {
      commit("setTrackingStatus", status);
    },
    swicthLanguage: ({ commit }, code) => {
      commit("setCurrentLangauge", code);
    },
    saveApplePayAvailibility: ({ commit }, value) => {
      commit("setNativeApplePayStatus", value)
    },
    saveGooglePayAvailibility: ({ commit }, value) => {
      commit("setNativeGooglePaystatus", value)
    },
    saveChannel: ({ commit }, channel) => {
      commit('setChannel', channel)
    },
    saveTrackedOrder: ({ commit }, payload) => {
      commit('setTreckedOrder', payload)
    },
    clearData: ({ commit }) => {
      commit('INIT_DATA')
    },
    storeWebAppVersion : ({commit}, payload) => {
      commit("setWebAppVersion", payload)
    }

  }
}